<button mat-menu-item *ngFor="let voice of voices" (click)="selectVoice(voice)">{{voice.name}}</button>
